import { Component, OnInit } from '@angular/core';
import {
  CampaignOffers,
  CampaignOffersQuery,
  CampaignOffersService,
  RewardsWalletItem,
  RewardsWalletQuery,
  RewardsWalletService,
} from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgb-wallet-claimed-page',
  templateUrl: './wallet-claimed-page.component.html',
  styleUrls: ['./wallet-claimed-page.component.scss'],
})
export class WalletClaimedPageComponent implements OnInit {
  walletItemsClaimed$: Observable<RewardsWalletItem[]>;
  campaignOffers$: Observable<CampaignOffers | undefined>;
  hasOfferItems: boolean = false;

  constructor(
    private rewardsWalletQuery: RewardsWalletQuery,
    private campaignOffersQuery: CampaignOffersQuery,
    private campaignOffersService: CampaignOffersService,
    private rewardsWalletService: RewardsWalletService
  ) {}

  ngOnInit() {
    firstValueFrom(this.campaignOffersService.fetchOffers());
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
    this.walletItemsClaimed$ = this.rewardsWalletQuery.selectRewardWalletItemsHistory();
    this.campaignOffers$ = this.campaignOffersQuery.selectFirst();
    this.campaignOffers$.subscribe((offers) => {
      if (offers && offers.CampaignsAndEntitlements.length > 0) {
        for (const campaign of offers.CampaignsAndEntitlements) {
          if (
            (campaign.voucherRedemptions > 0 && campaign.voucherUsesAvailable === campaign.voucherRedemptions) ||
            campaign.campaignRedemptions_Quantity >= 1
          ) {
            this.hasOfferItems = true;
            break;
          }
        }
      }
    });
  }
}
